import { ISearchResult } from 'api/common.types'
import { IReconData } from 'api/recondata.types'
import { ActionType, createAction } from 'typesafe-actions'
import {
  IBreakDetailAttrCountRes,
  IDQRActionsRequest,
  IReconDetailsReq,
  IReconDetailsRes,
  ISetAPIResponseOutput
} from '../api/types'

export const FETCH_RECON_DETAILS_REQUEST = `@modules/@reconData/FETCH_RECON_DETAILS_REQUEST`
export const FETCH_RECON_DETAILS_SUCCESS = `@modules/@reconData/FETCH_RECON_DETAILS_SUCCESS`
export const FETCH_RECON_DETAILS_FAILURE = `@modules/@reconData/FETCH_RECON_DETAILS_FAILURE`
export const FETCH_RECON_DETAILS_CLEAR = `@modules/@reconData/FETCH_RECON_DETAILS_CLEAR`

export const fetchReconDetailsActions = {
  request: createAction(FETCH_RECON_DETAILS_REQUEST)<IReconDetailsReq>(),
  success: createAction(FETCH_RECON_DETAILS_SUCCESS)<IReconDetailsRes>(),
  failure: createAction(FETCH_RECON_DETAILS_FAILURE)<Error>(),
  clear: createAction(FETCH_RECON_DETAILS_CLEAR)()
}

export const ADD_COMMENTS_RECON_REQUEST = `@modules/@reconData/ADD_COMMENTS_RECON_REQUEST`
export const ADD_COMMENTS_RECON_SUCCESS = `@modules/@reconData/ADD_COMMENTS_RECON_SUCCESS`
export const ADD_COMMENTS_RECON_FAILURE = `@modules/@reconData/ADD_COMMENTS_RECON_FAILURE`
export const ADD_COMMENTS_RECON_CLEAR = `@modules/@reconData/ADD_COMMENTS_RECON_CLEAR`
export const SET_OPEN_DETAILED_VIEW = `@modules/@reconData/SET_OPEN_DETAILED_VIEW`
export const SET_ACTIVE_TAB = `@modules/@reconData/SET_ACTIVE_TAB`

export const addCommentsReconActions = {
  setDetailedViewOpen: createAction(SET_OPEN_DETAILED_VIEW)<boolean>(),
  setActiveTab: createAction(SET_ACTIVE_TAB)<string>(),
  request: createAction(ADD_COMMENTS_RECON_REQUEST)<IDQRActionsRequest>(),
  success: createAction(ADD_COMMENTS_RECON_SUCCESS)<ISetAPIResponseOutput>(),
  failure: createAction(ADD_COMMENTS_RECON_FAILURE)<Error>(),
  clear: createAction(ADD_COMMENTS_RECON_CLEAR)()
}

export const RECONSUMMARY_SEARCH_REQUEST = `@modules/@reconData/RECONSUMMARY_SEARCH_REQUEST`
export const RECONSUMMARY_SEARCH_SUCCESS = `@modules/@reconData/RECONSUMMARY_SEARCH_SUCCESS`
export const RECONSUMMARY_SEARCH_FAILURE = `@modules/@reconData/RECONSUMMARY_SEARCH_FAILURE`
export const RECONSUMMARY_SEARCH_CLEAR = `@modules/@reconData/RECONSUMMARY_SEARCH_CLEAR`

export const reconSummarySearchActions = {
  request: createAction(RECONSUMMARY_SEARCH_REQUEST)<any>(),
  success: createAction(RECONSUMMARY_SEARCH_SUCCESS)<
    ISearchResult<IReconData>
  >(),
  failure: createAction(RECONSUMMARY_SEARCH_FAILURE)<Error>(),
  clear: createAction(RECONSUMMARY_SEARCH_CLEAR)()
}

export const FETCH_BREAK_DETAIL_ATTR = `@modules/@reconData/FETCH_BREAK_DETAIL_ATTR`
export const FETCH_BREAK_DETAIL_ATTR_SUCCESS = `@modules/@reconData/FETCH_BREAK_DETAIL_ATTR_SUCCESS`
export const FETCH_BREAK_DETAIL_ATTR_FAILURE = `@modules/@reconData/FETCH_BREAK_DETAIL_ATTR_FAILURE`
export const FETCH_BREAK_DETAIL_ATTR_CLEAR = `@modules/@reconData/FETCH_BREAK_DETAIL_ATTR_CLEAR`

export const fetchBreakDetailAttrActions = {
  request: createAction(FETCH_BREAK_DETAIL_ATTR)(),
  success: createAction(
    FETCH_BREAK_DETAIL_ATTR_SUCCESS
  )<IBreakDetailAttrCountRes>(),
  failure: createAction(FETCH_BREAK_DETAIL_ATTR_FAILURE)<Error>(),
  clear: createAction(FETCH_BREAK_DETAIL_ATTR_CLEAR)<undefined>()
}

export const FETCH_RESOLVED_COUNT = `@modules/@reconData/FETCH_RESOLVED_COUNT`
export const FETCH_RESOLVED_COUNT_SUCCESS = `@modules/@reconData/FETCH_RESOLVED_COUNT_SUCCESS`
export const FETCH_RESOLVED_COUNT_FAILURE = `@modules/@reconData/FETCH_RESOLVED_COUNT_FAILURE`
export const FETCH_RESOLVED_COUNT_CLEAR = `@modules/@reconData/FETCH_RESOLVED_COUNT_CLEAR`

export const fetchResolvedCountActions = {
  request: createAction(FETCH_RESOLVED_COUNT)(),
  success: createAction(FETCH_RESOLVED_COUNT_SUCCESS)<number>(),
  failure: createAction(FETCH_RESOLVED_COUNT_FAILURE)<Error>(),
  clear: createAction(FETCH_RESOLVED_COUNT_CLEAR)<undefined>()
}

// Graph group users cached in module state for reuse across panels/components
export const SET_GROUP_USERS = `@modules/@reconData/SET_GROUP_USERS`
export const CLEAR_GROUP_USERS = `@modules/@reconData/CLEAR_GROUP_USERS`

export const groupUsersActions = {
  set: createAction(SET_GROUP_USERS)<{ users: any[] }>(),
  clear: createAction(CLEAR_GROUP_USERS)()
}

export type fetchReconDetailsActionsType = ActionType<
  typeof fetchReconDetailsActions
>
export type addCommentsReconActionsType = ActionType<
  typeof addCommentsReconActions
>
export type reconSummarySearchActionsType = ActionType<
  typeof reconSummarySearchActions
>
export type fetchBreakDetailAttrType = ActionType<
  typeof fetchBreakDetailAttrActions
>
export type fetchResolvedCountType = ActionType<
  typeof fetchResolvedCountActions
>
export type ReconDataActionsTypes =
  | fetchReconDetailsActionsType
  | addCommentsReconActionsType
  | reconSummarySearchActionsType
  | fetchBreakDetailAttrType
  | fetchResolvedCountType
  | ActionType<typeof groupUsersActions>
